module.exports = __webpack_public_path__ + "static/img/logo-DBG.a2257c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/logo-DBG.png
// module id = z8l0
// module chunks = 1